// src/redux/userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    userInfo: null,
    storeInfo: null,
  },
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    setUserStoreInfo: (state, action) => {
      state.storeInfo = action.payload;
    },
  },
});

export const { setUserInfo, setUserStoreInfo } = userSlice.actions;
export default userSlice.reducer;
